export const categoryTypeOptions = [
  { value: 'content', label: 'App' },
  { value: 'device', label: 'Device' },
  { value: 'geo', label: 'Geo' },
  { value: 'screen', label: 'Screen (Mobile)' },
  { value: 'network', label: 'Network Request' },
  { value: 'events', label: 'Events' },
  { value: 'errors', label: 'Errors' },
  { value: 'page', label: 'Page (Web)' },
  // { value: 'custom', label: 'Custom' },
  { value: 'global_tags', label: 'Global Tags' },
  { value: 'event_tags', label: 'Event Tags' },
];

export const categoryTypeMap = {
  content: 'App',
  device: 'Device',
  geo: 'Geo',
  screen: 'Screen (Mobile)',
  network: 'Network Request',
  events: 'Events',
  errors: 'Errors',
  page: 'Page (Web)',
  custom: 'Custom',
  global_tags: 'Global Tags',
  event_tags: 'Event Tags',
  campaign: 'UTM Parameters (Web)',
};

export const EMPTY_ARRAY = [];

export const EVENT_KEYS_PREFIX = '__event__';
export const GLOBAL_KEYS_PREFIX = '__global__';

export const GLOBAL_TAG_TAB_KEY = 'Global Tag Key';
export const EVENT_TAG_TAB_KEY = 'Event Tag Key';

export const MAPPED_EVENT_TAB_KEY = 'Mapped Event';
export const UNMAPPED_EVENT_TAB_KEY = 'Unmapped Event';
